import React from "react";
import { ApolloProvider } from "@apollo/client";
export const OneGraphProvider = ({ client, children, }) => React.createElement(ApolloProvider, { client: client }, children);
//# sourceMappingURL=one-graph-provider.js.map